import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import type { AdminApi, RecentObjectView } from '../../api/client.ts';

/** Opening an object page records the view for «Pick up where you left off» on Home (BB-133); failures are silent. */
export function useRecordView(environmentId: string, objectType: RecentObjectView['objectType'], objectId: string, enabled = true) {
  const { api } = useRouter().options.context as { api: AdminApi };
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    api
      .markViewed(environmentId, objectType, objectId)
      .then(() => queryClient.invalidateQueries({ queryKey: ['home', environmentId, 'recent'] }))
      .catch(() => undefined);
  }, [api, queryClient, environmentId, objectType, objectId, enabled]);
}
